<script lang="ts">
	//UI
	//Utils
	//Types
	//Props
	export let fill = "#6d6f76";
	export let open = false;
	//Constants
	//Variables
	//Functions
	//Do

</script>

<svg
	xmlns="http://www.w3.org/2000/svg"
	width="100%"
	height="100%"
	class:open
	viewBox="0 0 19.738 10">
	<g>
		<g>
			<path
				d="M.44 19.738a.44.44 0 0 1-.316-.746l8.824-9.123L.124.746A.44.44 0 0 1 .756.134l9.12 9.429a.44.44 0 0 1 0 .612L.756 19.6a.441.441 0 0 1-.316.138z"
				transform="rotate(90 9.869 9.869)"
				fill={fill} />
		</g>
	</g>
</svg>

<style lang="scss">
	svg {
		&.open {
			rotate: 180deg;
		}
	}

</style>
